import AmlGeneralInfoWrapper from '../../partial/aml/general-info';
import { AMLGeneralInfoTypes } from '../types';
// import AmlGeneralInfoRow from '../../partial/aml/general-info-row';
// import { CorporateAmlGeneralInfo } from '../../../hoc/corporate/types';

const AmlGeneralInfo = ({
  isLoading,
  // amlGeneralInfo,
  nextReviewDate,
  auditLogAllowed,
  setChangeLogPanelIsOpen,
}: AMLGeneralInfoTypes): React.JSX.Element => (
  <AmlGeneralInfoWrapper
    isLoading={isLoading}
    nextReviewDate={nextReviewDate}
    auditLogAllowed={auditLogAllowed}
    setChangeLogPanelIsOpen={setChangeLogPanelIsOpen}
  >
    <div />
    {/* <>
      <AmlGeneralInfoRow title="Entity form" value={amlGeneralInfo?.entityForm.toUpperCase()} />
      <AmlGeneralInfoRow title="Nature (SIC)" value={amlGeneralInfo?.sic} />
      <AmlGeneralInfoRow title="MCC" value={amlGeneralInfo?.mcc} />
      <AmlGeneralInfoRow title="Description" value={amlGeneralInfo?.description} />
    </> */}
  </AmlGeneralInfoWrapper>
);

export default AmlGeneralInfo;
